<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
        <div calss="form-group row">
                <div class="col-md-6">
                    <h1>REKAPITULACIJA PO KOMITENTIMA - opis</h1>            
                </div>    
                    </div> 
  <div class="row">
      <div class="col-lg-6 col-12">
          <div class="form-group row">
              <div class="col-md-6">
                  <yt-fw-date-picker-popup
                      name="txtOdDatuma"
                      formControlName="OdDatuma"
                      [ngClass]="{'is-invalid' : submitted && fc.OdDatuma.invalid}"
                      [Label]="'REKAPITULACIJAPOKOMITENTIMA.ODDATUMA.SINGULAR'">
                  </yt-fw-date-picker-popup>
                  <div class="form-error" *ngIf="submitted && fc.OdDatuma.invalid">
                      <span *ngFor="let validation of errorMessages.OdDatuma">
                          <span class="error-message" *ngIf="fc.OdDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                  </div>
              </div>
              <div class="col-md-6">
                  <yt-fw-date-picker-popup
                      name="txtDoDatuma"
                      formControlName="DoDatuma"
                      [ngClass]="{'is-invalid' : submitted && fc.DoDatuma.invalid}"
                      [Label]="'REKAPITULACIJAPOKOMITENTIMA.DODATUMA.SINGULAR'">
                  </yt-fw-date-picker-popup>
                  <div class="form-error" *ngIf="submitted && fc.DoDatuma.invalid">
                      <span *ngFor="let validation of errorMessages.DoDatuma">
                          <span class="error-message" *ngIf="fc.DoDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                  </div>
              </div>
          </div>
      </div>
  </div>  
  <div class="row">
      <div class="col-lg-6 col-12">
          <div class="form-group row">
              <!-- <label class="control-label col-md-2"><span>Komitent</span></label> -->
              <div class="col-md-12">
                  <yt-multiselect
                      [ModelName]="'komitent'"
                      [GetName]="'get'"
                      [ModelProperty]="'SNaziv'"
                      [OrderBy]="'SNaziv'"
                      formControlName="Komitent"
                      [AllowAddNew]="false" 
                      [Type]="'ID'"
                      [Label]="'REKAPITULACIJAPOKOMITENTIMA.KOMITENT.SINGULAR'"
                      [ngClass]="{'is-invalid': submitted && fc.Komitent.invalid}">
                  </yt-multiselect>
                  <div class="form-error" *ngIf="submitted && fc.Komitent.invalid">
                    <span *ngFor="let validation of errorMessages.Komitent">
                        <span class="error-me ssage" *ngIf="fc.Komitent.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
              </div>
          </div>
      </div>
  </div>
  <div class="row">
      <div class="col-lg-6 col-12">
          <div class="form-group row">
              <!-- <label class="control-label col-md-2"><span>Organ. jed.</span></label> -->
              <div class="col-md-12">
                  <yt-multiselect
                      [ModelName]="'orgjed'"
                      [GetName]="'getParentAndChildByParentID'"
                      [ModelProperty]="'Naziv'"
                      [OrderBy]="'Naziv'"
                      formControlName="OrgJedIDS"
                      [AllowAddNew]="false" 
                      [Type]="'ID'"
                      [Label]="'REKAPITULACIJAPOKOMITENTIMA.ORGJED.SINGULAR'"  
                      [ngClass]="{'is-invalid': submitted && fc.OrgJed.invalid}"
                      (GetItems)="SkupiOrgJed($event)">
                  </yt-multiselect>
                  <div class="form-error" *ngIf="submitted && fc.OrgJed.invalid">
                    <span *ngFor="let validation of errorMessages.OrgJed">
                        <span class="error-me ssage" *ngIf="fc.OrgJed.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
              </div>
          </div>
      </div>
  </div>
  <div class="row">
      <div class="col-lg-6 col-12">
          <div class="form-group row">
              <label for="rdbGrupisanoPo" class="control-label col-md-2"><span translate="REKAPITULACIJAPOKOMITENTIMA.VRSTA.IZVESTAJ"></span></label>
              <div class="col-md-2">
                  <label class="radio-inline">
                      <input type="radio" value=1 formControlName="Vrsta">
                      <span translate="REKAPITULACIJAPOKOMITENTIMA.VRSTA.ANALITIKA"></span>
                  </label>
              </div>
              <div class="col-md-2">
                  <label class="radio-inline">
                      <input type="radio" value=2 formControlName="Vrsta">
                      <span translate="REKAPITULACIJAPOKOMITENTIMA.VRSTA.SINTETIKA"></span>
                  </label>
              </div>
          </div>
      </div>
  </div>
  <div class="row">
      <div class="col-sm-12">
        <div class="form-check">
          <input
          style="width: 20px;"
            type="checkbox"
            class="form-check-input"
            id="cbPrikaziDonos"
            formControlName="Donos"
          >
          <label class="form-check-label" for="cbPrikaziDonos"><span translate="REKAPITULACIJAPOKOMITENTIMA.PRIKAZIDONOS.SINGULAR"></span></label>
        </div>
      </div>           
  </div>   
 
  <div class="row mt-2">
      <div class="col-md-12">
          <button type="button" class="btn btn-primary" (click)="LoadPDF()">Učitaj</button>
      </div>
  </div>
</form>